import './registerform.less'

import {hasT, t} from 'store'

import Button from '../views/layout/button'
import {Component} from '@codeurs/front'
import ContactForm from './contactform'
import {LinkType} from '../types/types'
import m from 'mithril'

type formFieldTypes =
	| 'text'
	| 'radio'
	| 'checkbox'
	| 'email'
	| 'tel'
	| 'textarea'

type formFieldOptions = {key: string; label: string}[]

const attendanceOptions = [
	{
		key: 'in_person',
		label: 'in person'
	},
	{
		key: 'online',
		label: 'online'
	}
]

export default class RegisterForm extends Component<{
	title: string
	path: string
	id: string
	fields: Array<string>
	links?: {
		privacy?: LinkType
		terms?: LinkType
	}
}> {
	form: any = new ContactForm({
		data: {
			has_participate: this.attrs.fields.indexOf('participate') >= 0,
			has_attendance_required:
				this.attrs.fields.indexOf('attendance_required') >= 0
		}
	})
	isCompleted = false
	view() {
		return m('.registerform#registerform', [
			m('h2.registerform-title',
				this.isCompleted ? t('register.thanks.title') : t('register.title')
			),
			this.isCompleted
				? this.viewThanks()
				: [
						m('.registerform-subtitle', [
							m('span', t('register.subtitle1')),
							this.redStar(),
							m('span', t('register.subtitle2'))
						]),
						this.viewForm()
				  ]
		])
	}

	redStar() {
		return m('span.registerform-star', '*')
	}

	viewThanks() {
		const {title} = this.attrs
		return m('.registerform-thanks', [
			m('h3.registerform-thanks-title', t('register.thanks.thanks') + title),
			m('.registerform-thanks-text', t('register.thanks.text'))
		])
	}

	viewForm() {
		const {fields, links, id, path} = this.attrs
		return m('form.registerform-form',
			{
				onsubmit: e => {
					e.preventDefault()
					if (this.form.status() === 'sending') {
						return
					}
					const {data} = this.form.fields.store
					m.request({
						method: 'POST',
						url: `/api/register/${id}/${path}`,
						data
					})
						.then(res => {
							console.log('Registration sent successfully')
							//scroll to top of registration
							const formEl = document.getElementById('registerform')
							if (formEl) {
								const formElInfo = formEl.getBoundingClientRect()
								window.scrollBy(0, formElInfo.top - 20)
							}
							this.isCompleted = true
							m.redraw()
						})
						.catch(err => {
							//map error field names
							const parsedError = JSON.parse(JSON.stringify(err))
							const errors = parsedError.response
							let cleanErrors = {}
							Object.keys(errors).forEach(key => {
								cleanErrors[key] = errors[key].map(errorMsg =>
									errorMsg
										.replace('fname', t('register.field.fname').trim())
										.replace('lname', t('register.field.lname').trim())
										.replace(
											'organization',
											t('register.field.organization').trim()
										)
										.replace('email', t('register.field.email').trim())
										.replace('term', t('register.termlink'))
										.replace(' when has participate is 1', '')
								)
							})
							this.form.store.status.errors = cleanErrors
							m.redraw()
						})
				}
			},
			[
				this.viewFormField('fname', true),
				this.viewFormField('lname', true),
				this.viewFormField('organization', true),
				this.viewFormField('email', true, 'email'),
				fields.map(key => {
					let type: formFieldTypes = 'text'
					let required: boolean = false
					let options: formFieldOptions = []

					switch (key) {
						case 'participate':
							type = 'radio'
							required = true
							break

						case 'lunch':
						case 'dinner':
							type = 'radio'
							break

						case 'mobile':
							type = 'tel'
							break

						case 'mobile_required':
							type = 'tel'
							required = true
							break

						case 'attendance':
							type = 'radio'
							options = attendanceOptions
							break

						case 'attendance_required':
							type = 'radio'
							required = true
							options = attendanceOptions
							break
					}
					return this.viewFormField(key, required, type, options)
				}),
				this.viewFormField('comments', false, 'textarea'),
				m('.registerform-column', [
					m('.registerform-form-field-checkbox', [
						m('label.registerform-form-field-checkbox-label', [
							this.viewFormInputField('term', true, 'checkbox'),
							m('span.registerform-form-field-label.mod-checkbox',
								t('register.field.term')
							)
						]),
						m('a.registerform-form-field-checkbox-link',
							{
								href: links.privacy ? links.privacy.url : '#',
								target: '_blank'
							},
							t('register.termlink')
						)
					]),
					m('.registerform-form-field-checkbox',
						m('label.registerform-form-field-checkbox-label', [
							this.viewFormInputField('optin', false, 'checkbox'),
							m('span.registerform-form-field-label.mod-checkbox',
								t('register.field.optin')
							)
						])
					)
				]),
				m('.registerform-column.mod-right', [
					m(Button,
						{
							type: 'submit',
							class: 'registerform-form-button',
							mod: 'more rounded ' + this.form.status()
						},
						t('register.cta')
					),
					this.form.store.status.errors && this.form.store.status.errors.invalid
						? m('.registerform-form-errormsg',
								this.form.store.status.errors.invalid
						  )
						: null
				])
			]
		)
	}

	viewFormField(
		key: string,
		required: boolean,
		type: formFieldTypes = 'text',
		options: formFieldOptions = []
	) {
		let label = [m('span', t('register.field.' + key))]
		if (hasT('register.field.' + key + '_sub'))
			label.push(
				m('span.registerform-form-field-label-sub',
					t('register.field.' + key + '_sub')
				)
			)
		if (required) label.push(this.redStar())
		const hasValue =
			this.form.store.data[key] && this.form.store.data[key] !== ''
		return m('.registerform-form-field-container.mod-' + type, [
			m('.registerform-form-field-label.mod-' + type + '.mod-' + key,
				{
					class: hasValue ? 'has-value' : ''
				},
				label
			),
			this.viewFormInputField(key, required, type, options)
		])
	}

	viewFormInputField(
		key: string,
		required: boolean = false,
		type: formFieldTypes = 'text',
		options: formFieldOptions = []
	) {
		const error =
			this.form.store.status.errors && this.form.store.status.errors[key]
		const hasError = error ? ' has-error' : ''
		switch (type) {
			case 'text':
				return this.form.text({
					key: key,
					required: required,
					className: 'registerform-form-field' + hasError,
					errors: error
				})
			case 'email':
				return this.form.email({
					key: key,
					required: required,
					className: 'registerform-form-field' + hasError,
					errors: error
				})
			case 'textarea':
				return this.form.textarea({
					key: key,
					required: required,
					className: 'registerform-form-textarea' + hasError,
					errors: error
				})
			case 'radio':
				return this.form.radio({
					key: key,
					required: required,
					className: 'registerform-form-radio',
					errors: error,
					options:
						options.length > 0
							? options
							: [
									{key: 'yes', label: 'yes'},
									{key: 'no', label: 'no'}
							  ]
				})
			case 'checkbox':
				return this.form.checkbox({
					key: key,
					required: required,
					errors: error
				})
			case 'tel':
				return this.form.tel({
					key: key,
					required: required,
					className: 'registerform-form-field' + hasError,
					errors: error
				})
			default:
				return 'Missing field type: ' + type
		}
	}
}
